/**
 * Kartli odemede Pavo cihazina gonderilecek odeme aracisi (PaymentMediatorId).
 *
 * Pavo, kart odemesini varsayilan olarak BKM/TechPOS altyapisina yonlendirir
 * (Mediator=2). Bu altyapida tanimli olmayan bankalar kendi araci kimlikleriyle
 * gonderilmek zorundadir: Albaraka TechPOS'ta olmadigi icin AlbarakaPOS ancak
 * Mediator=38 ile calisir, 2 ile gonderilen istek o cihazlarda karsilik bulmuyor.
 *
 * Ayarin tek kaynagi hizli satis ekrani ayarlaridir (QuickSaleScreens.
 * PavoPaymentMediatorId). Ekran bileseni aktif degeri buraya yazar; pavopay.ts
 * gibi hook-disi helper'lar da buradan okur — restP2PConfig ile ayni desen.
 *
 * Nakit (Mediator=1) ve yemek karti (ExternalPayments + Brand) bu ayardan
 * ETKILENMEZ; yalnizca kart bacagi yonlendirilir.
 */

/** Pavo'nun kart odemesini BKM/TechPOS altyapisina yonlendiren varsayilan araci. */
export const DEFAULT_PAVO_CARD_MEDIATOR = 2;

/** Ayar ekranindaki secenekler. Yeni bir banka eklenecekse tek yer burasidir. */
export const PAVO_CARD_MEDIATOR_OPTIONS: { id: number; label: string }[] = [
  { id: DEFAULT_PAVO_CARD_MEDIATOR, label: 'BKM / TechPOS' },
  { id: 38, label: 'AlbarakaPOS' },
];

const STORAGE_KEY = 'gts_pavo_card_mediator';

let current: number = DEFAULT_PAVO_CARD_MEDIATOR;
let loadedFromStorage = false;

/**
 * Gecerli bir araci kimligi mi? 0/NaN/negatif degerler ayari bozmasin diye
 * hem yazarken hem okurken suzuluyor.
 */
const normalize = (value: unknown): number | null => {
  const id = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(id) && id > 0 ? Math.trunc(id) : null;
};

export function setPavoCardMediator(mediatorId: number | null | undefined): void {
  const id = normalize(mediatorId) ?? DEFAULT_PAVO_CARD_MEDIATOR;
  current = id;
  loadedFromStorage = true;
  try {
    // Sayfa yenileme / HMR sonrasi kurtarma icin
    localStorage.setItem(STORAGE_KEY, String(id));
  } catch (_) {}
}

export function clearPavoCardMediator(): void {
  current = DEFAULT_PAVO_CARD_MEDIATOR;
  loadedFromStorage = true;
  try { localStorage.removeItem(STORAGE_KEY); } catch (_) {}
}

/**
 * Kartli odemede kullanilacak araci kimligi. Ayar hic yazilmamissa (or. sayfa
 * yenilenmis, ekran bileseni henuz mount olmamis) localStorage'dan kurtarilir,
 * o da yoksa BKM/TechPOS varsayilanina duser.
 */
export function getPavoCardMediator(): number {
  if (!loadedFromStorage) {
    loadedFromStorage = true;
    try {
      const id = normalize(localStorage.getItem(STORAGE_KEY));
      if (id !== null) current = id;
    } catch (_) {}
  }
  return current;
}

/** Log/uyari metinlerinde okunabilir isim. Bilinmeyen id ham haliyle gosterilir. */
export function getPavoCardMediatorLabel(mediatorId?: number): string {
  const id = mediatorId ?? getPavoCardMediator();
  return PAVO_CARD_MEDIATOR_OPTIONS.find(o => o.id === id)?.label ?? `Mediator ${id}`;
}
